<template>
  <div>
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="active">结算列表</span>
    </div>

    <div class="page">
      <Search ref="search" :searchConfig="searchConfig" @doSearch="doSearch">
        <template :slot="'btns'">
          <el-button type="primary" size="small" @click="onAdd()"
            >新建</el-button
          >
        </template>
      </Search>
      <Table ref="table" class="table" :tableConfig="tableConfig">
        <template :slot="'ssoSupplierSettleOrderNo'" slot-scope="scope">
          <a href="javascript:;" @click="onDetail(scope.row)">{{
            scope.row.ssoSupplierSettleOrderNo
          }}</a>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from "../component/table.vue";
import Search from "../component/search.vue";
export default {
  components: {
    Table,
    Search,
  },
  data() {
    return {
      searchConfig: {
        params: [
          {
            prop: "projectName",
            label: "项目名称",
          },
          {
            prop: "deviceName",
            label: "装置名称",
          },
          {
            prop: "demandTableNo",
            label: "申请单号",
          },
          {
            prop: "projectManager",
            label: "项目经理",
          },
          {
            prop: "workStatus",
            label: "工作类型",
            searchType: "select",
            options: window.SITE_CONFIG.dictList["OMS_SSO_WORK_STATUS"] || [],
            props: {
              label: "value",
              value: "code",
            },
          },
          {
            prop: "supplierOrderCreateTime",
            label: "填报日期",
          },
          {
            prop: "ssoSupplierSettleStatus",
            label: "已提交结算",
            searchType: "select",
            options: [
              {
                label: "未提交",
                value: "1",
              },
              {
                label: "已提交",
                value: "2",
              },
            ],
          },
        ],
      },
      tableConfig: {
        searchUrl: "/front/oms/omsSsoSupplierSettle/page", // 搜索接口
        searchMethod: "POST", // 接口请求方式
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: false, // 是否显示序号,
        count: "total",
        resultListName: "records",
        params: [
          {
            prop: "ssoSupplierSettleOrderNo",
            label: "结算单号",
            isSlot: true,
          },
          {
            prop: "projectName",
            label: "项目名称",
          },
          {
            prop: "demandTableNo",
            label: "申请单号",
          },
          {
            prop: "deviceName",
            label: "装置名称",
          },
          {
            prop: "projectManager",
            label: "项目经理",
          },
          {
            prop: "workStatusStr",
            label: "工作状态",
          },
          {
            prop: "supplierOrderCreateTime",
            label: "填报日期",
          },
          {
            prop: "deliveryNum",
            label: "工时",
          },
          {
            prop: "ssoSupplierSettleStatusStr",
            label: "提交结算",
          },
        ],
        extra: {},
      },
    };
  },
  mounted() {
    this.$refs.search.doSearch();
  },
  methods: {
    doSearch(params) {
      this.tableConfig.extra = {
        ...params,
        companyId: this.$store.state.user.defaultCompanyId,
      };
      // 工程师需要传 userId
      if (this.$store.state.ecology.userInfo.userType == 2) {
        this.tableConfig.extra.userId = this.$store.state.user.userId;
      }
      this.$refs.table.getList();
    },
    onAdd() {
      this.$router.push({
        path: "/ecologicalServices/settlement-edit",
      });
    },
    onEdit(row) {
      this.$router.push({
        path: "/ecologicalServices/settlement-edit",
        query: {
          id: row.id,
        },
      });
    },
    onDetail(row) {
      this.$router.push({
        path: "/ecologicalServices/settlement-detail",
        query: {
          id: row.id,
        },
      });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  padding: 20px;
}

.table {
  height: 720px;
}
</style>
